
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#224CA4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.419 2.603A.694.694 0 0015.733 2a.695.695 0 00-.693.698v.771H8.968v-.771l-.006-.095A.694.694 0 008.276 2a.695.695 0 00-.692.698v.788C4.747 3.682 3 5.52 3 8.486v8.418C3 20.087 4.958 22 8.096 22h7.808C19.045 22 21 20.12 21 16.974V8.486c.009-2.967-1.732-4.805-4.575-5v-.788l-.006-.095zM15.04 4.864v.895l.007.095c.045.34.335.603.686.603a.695.695 0 00.692-.698v-.874c2.069.172 3.197 1.418 3.19 3.599v.404H4.385v-.402c0-2.18 1.134-3.428 3.199-3.6v.873l.006.095c.046.34.335.603.686.603a.695.695 0 00.692-.698v-.895h6.072zM4.385 10.283v6.621c0 2.403 1.329 3.7 3.711 3.7h7.808c2.39 0 3.711-1.27 3.711-3.63v-6.691H4.385zM16.8 13.218a.695.695 0 00-.692-.697l-.103.006a.696.696 0 00-.598.691c0 .386.31.698.7.698l.095-.006a.696.696 0 00.598-.692zm-4.788-.697c.382 0 .692.312.692.697 0 .354-.26.645-.598.692l-.094.006c-.391 0-.701-.312-.701-.698 0-.353.26-.645.598-.691l.103-.006zm-3.413.697a.695.695 0 00-.692-.697l-.102.006a.696.696 0 00-.599.691c0 .386.31.698.693.698l.102-.006a.696.696 0 00.598-.692zm7.509 2.918c.382 0 .692.312.692.698 0 .353-.26.645-.598.691l-.094.006c-.391 0-.701-.312-.701-.697 0-.354.26-.645.598-.692l.103-.006zm-3.404.698a.695.695 0 00-.692-.698l-.103.006a.696.696 0 00-.598.692c0 .385.31.697.7.697l.095-.006a.696.696 0 00.598-.691zm-4.797-.698c.382 0 .692.312.692.698 0 .353-.26.645-.598.691l-.102.006a.695.695 0 01-.693-.697c0-.354.26-.645.599-.692l.102-.006z","fill":"inherit"}})])
          )
        }
      }
    